import React from 'react';
import { Card } from './ui/card';
import { quickActions } from '../data/mockData';
import { HelpCircle, Calendar, UserPlus } from 'lucide-react';

const iconMap = {
  'help-circle': HelpCircle,
  'calendar': Calendar,
  'user-plus': UserPlus
};

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-white py-24 relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Quick action cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {quickActions.map((action) => {
            const Icon = iconMap[action.icon];
            return (
              <Card
                key={action.id}
                className="group relative overflow-hidden rounded-3xl border-none shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-white"
              >
                <a href={action.link} className="block p-8 text-center">
                  <div className="mb-4 flex justify-center">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FFE8E0] to-[#FFD0C0] flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-[#FF6347]" />
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-[#1A4D4D] mb-2" style={{ fontFamily: 'Quicksand, sans-serif' }}>
                    {action.title}
                  </h3>
                  <p className="text-[#FF6347] font-medium text-lg">{action.subtitle}</p>
                </a>
              </Card>
            );
          })}
        </div>

        {/* Footer bottom */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/l12ezb91_Naamloos.png" 
              alt="KS Care Logo" 
              className="h-16 w-auto"
            />
          </div>
          <p className="text-gray-600 text-sm mb-6">
            Dagbesteding & Logeeropvang voor jeugd met een lichamelijke of verstandelijke beperking
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500 mb-4">
            <a href="tel:0619199023" className="hover:text-[#FF6347] transition-colors duration-200">
              06-19199023
            </a>
            <span>•</span>
            <a href="mailto:info@kscare.nl" className="hover:text-[#FF6347] transition-colors duration-200">
              info@kscare.nl
            </a>
          </div>
          <div className="text-sm text-gray-500 mb-4">
            <p>Delweide 34, 6118 AH Nieuwstadt</p>
            <p className="mt-1">KVK: 85306452 | Handelsnaam: KS Care</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500">
            <a href="/privacy" className="hover:text-[#FF6347] transition-colors duration-200">
              Privacy
            </a>
            <span>•</span>
            <a href="/algemene-voorwaarden" className="hover:text-[#FF6347] transition-colors duration-200">
              Algemene voorwaarden
            </a>
            <span>•</span>
            <a href="/contact" className="hover:text-[#FF6347] transition-colors duration-200">
              Contact
            </a>
          </div>
          <p className="text-gray-400 text-xs mt-6">
            © 2024 KS Care. Alle rechten voorbehouden.
          </p>
          <p className="text-gray-400 text-xs mt-2">
            Financiering mogelijk via WLZ, WMO en Jeugdwet
          </p>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-10 right-10 opacity-10 hidden xl:block">
        <svg width="80" height="120" viewBox="0 0 80 120" fill="none">
          <circle cx="40" cy="35" r="30" fill="#52BE80" />
          <circle cx="25" cy="55" r="20" fill="#52BE80" />
          <circle cx="55" cy="50" r="23" fill="#52BE80" />
          <rect x="35" y="70" width="10" height="50" fill="#A0826D" />
        </svg>
      </div>
    </footer>
  );
};

export default Footer;